import './pickList.css'

/** Часовые пояса отчётов: границы дней и время чеков всех источников считаются в одном поясе. */
export const REPORT_TIME_ZONES = [
  { value: 'UTC', label: 'UTC' },
  { value: 'Europe/Moscow', label: 'Москва · UTC+3' },
  { value: 'Asia/Yekaterinburg', label: 'Екатеринбург · UTC+5' },
] as const

/**
 * Маленький выбор часового пояса отчёта — для правого верхнего угла экрана, без блока и пояснений.
 * Подпись для диктора есть, на экране её нет: значение (`Москва · UTC+3`) говорит само за себя.
 */
export function TimeZoneSelect({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  return (
    <div className="krp-timezone">
      <select aria-label="Часовой пояс отчёта" className="krp-timezone__select" value={value} onChange={(event) => onChange(event.target.value)}>
        {REPORT_TIME_ZONES.map((zone) => <option key={zone.value} value={zone.value}>{zone.label}</option>)}
      </select>
    </div>
  )
}
